import HundredBricksAPIError from '../../HundredBricksAPIError';
class RegisterZipCodeError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('RegisterZipCodeError', ...args);
    }
}
export default RegisterZipCodeError;
